import { render, staticRenderFns } from "./userBehavior.vue?vue&type=template&id=1395765c"
import script from "./userBehavior.vue?vue&type=script&lang=js"
export * from "./userBehavior.vue?vue&type=script&lang=js"
import style0 from "./userBehavior.vue?vue&type=style&index=0&id=1395765c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports